<template>
  <div>
    <div class="justify-content-center row menutab">
      <div class="col-auto" v-for="(link, index) in routes" :key="index">
        <button :class="['btn', { active: $route.path === link.path }]" @click="navigate(link.path, link.name)">
          {{ link.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalystInfoTabMenu',
  data() {
    return {
      routes: [
        { name: 'ติดต่อนักวิเคราะห์', path: '/analystinfo' },
        { name: 'บทวิเคราะห์หลักทรัพย์', path: '/securitiesanalysis' },
      ],
    };
  },
  methods: {
    navigate(path, name) {
      if (this.$route.path !== path) {
        this.$router.push({ path });
      } else {
        console.log(`Already on the page: ${path}`);
      }
    },
  }
};
</script>

<style scoped>
.menutab {
  padding: 10px;
  margin-right: 80px;
  margin-left: 80px;
}

.menutab .col-auto {
  margin-bottom: 10px;
  flex: 1;
}

.menutab .col-auto .btn {
  background-color: transparent;
  color: #000000;
  border: 1px solid #000000;
  padding: 10px;
  display: block;
  width: 100%;
  cursor: pointer;
  text-align: center;
  white-space: nowrap; /* Prevent text wrapping */
}

.menutab .col-auto .btn.active {
  color: #ffffff;
  border: 1px solid #E87D2E;
  background-color: #E87D2E;
}

.menutab .col-auto .btn:hover {
  color: #555;
}
@media (max-width: 991px) {
  .menutab {
    padding: 10px;
    margin-right: 0;
    margin-left: 0;
  }
  .menutab .col-auto .btn {
   font-size: 13px;
  }
}
</style>
